import { useContext, useRef } from 'react';
import ArrowRight from '../../../assets/icons/ArrowRight';
import Button from '../../../ui/Button';
import Heading from '../../../ui/Heading';

import ArrowLeft from '../../../assets/icons/ArrowLeft';
import MintedBack from './MintedBack';
import OverlayCard from '../../../ui/OverlayCard';
import { ProfileContext } from '../../../contexts/ProfileContext';
import MintedCard from './MintedCard';
import NoDataAvailable from '../../../ui/NoDataAvailable';
import OverlayCardProject from '../../../ui/OverlayCardProject';
import MintedProject from './MintedProject';
import MintedProjectBack from './MintedProjectBack';

// import ClaimedCertificateBack from './ClaimedCertificateBack';

function AllMintedCards() {
    const { state } = useContext(ProfileContext);
    const mintedIcs = state.filter((ic) => ic.status === 'MINTED');
    const scrollCards = useRef();
    function scrollR() {
        scrollCards.current.scrollBy({
            left: 334,
            behavior: 'smooth',
        });
    }
    function scrollL() {
        scrollCards.current.scrollBy({
            left: -334,
            behavior: 'smooth',
        });
    }
console.log(mintedIcs,"ye minted ics h yha dekho timestamp");
    return (
        <div className="mt-8">
            <Heading className={`text-textGrayHeading leading-10`} type={'medium'}>
                Minted 
            </Heading>
            <div className="relative">
                <div
                    verticalMargin=""
                    ref={scrollCards}
                    className="  flex items-center overflow-auto   scrollableCards"
                >
                    {mintedIcs.length > 0 ? (
                        mintedIcs.map((ic) => {

                        return    ic?.projectId ?  <OverlayCardProject
                                    width="w-[39.8125rem]"
                                    height="h-[25.625rem]"
                                    fixW="w-[39.8125rem]"
                                    key={ic.id + ic.status}
                                    image={ic.imageUri}
                                    ic={ic}
                                    FrontCard={MintedProject}
                                    BackCard={MintedProjectBack}
                                />   : 
                             (
                                <OverlayCard
                                    width="w-[346px]"
                                    height="h-[25.625rem]"
                                    fixW="w-[346px]"
                                    key={ic.id + ic.status}
                                    image={ic.image}
                                    ic={ic}
                                    FrontCard={MintedCard}
                                    BackCard={MintedBack}
                                />
                            );
                        })
                    ) : (
                        <div className="flex w-full items-center justify-center">
                            <NoDataAvailable marginTop="mt-3" />
                        </div>
                    )}
                </div>
                <Button
                    radius="rounded-full"
                    onClick={scrollL}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -left-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowLeft fillColor="#606060" />
                </Button>

                <Button
                    radius="rounded-full"
                    onClick={scrollR}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -right-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowRight fillColor={'#606060'} />
                </Button>
            </div>
        </div>
    );
}

export default AllMintedCards;
